/* Common optical group: native chat access follows reading content. */
(()=>{
  if(window.__ogContextHelp)return;
  window.__ogContextHelp=true;
  const roots=new WeakSet();let queued=false,host=null,slot=null;
  const enqueue=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;sync();});};
  const discover=node=>{
    if(node.shadowRoot)watch(node.shadowRoot);
    node.querySelectorAll('*').forEach(e=>{if(e.shadowRoot)watch(e.shadowRoot);});
  };
  const watch=root=>{
    if(roots.has(root))return;
    roots.add(root);
    new MutationObserver(records=>{
      // Discover new components once; state changes do not rescan their entire trees.
      records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)discover(node);}));
      enqueue();
    }).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-expanded','open','aria-hidden','class','style','hidden']});
    discover(root);
  };
  const toggle=(element,name,value)=>{
    if(element.classList.contains(name)!==value)element.classList.toggle(name,value);
  };
  // Native dialogs and the existing Motive search own the foreground until dismissed.
  const taskPanels='dialog[open],[role="dialog"][aria-modal="true"]';
  const collectionPanels='#menu-drawer,#facets-drawer,.facets-drawer,.oh-native-tag-drawer,.oh-collection-filter__panel,#oh-tagsheet';
  const panelOpen=panel=>{
    watch(panel);
    if(panel.shadowRoot)watch(panel.shadowRoot);
    // Explicit open and hidden surfaces need no geometric query.
    // Closing animations remain foreground until their surface is actually hidden.
    if(panel.hasAttribute('open'))return true;
    const surface=panel.shadowRoot?.querySelector('[part="content"]')||panel;
    const style=getComputedStyle(surface);
    if(style.display==='none'||style.visibility==='hidden')return false;
    return !!surface.getClientRects().length;
  };
  const taskOpen=root=>{
    if(!root)return false;
    return [...root.querySelectorAll(taskPanels)].some(panel=>!panel.matches(collectionPanels)&&panelOpen(panel));
  };
  const state=(name,value)=>{
    if(document.documentElement.classList.contains(name)!==value)document.documentElement.classList.toggle(name,value);
  };
  const expanded=root=>{
    watch(root);
    if(root.querySelector('button.activator[aria-expanded="true"]'))return true;
    return [...root.querySelectorAll('*')].some(e=>e.shadowRoot&&expanded(e.shadowRoot));
  };
  const sync=()=>{
    const motive=document.getElementById('motive-container')?.shadowRoot;
    if(motive)watch(motive);
    const menu=document.getElementById('menu-drawer');
    const navigation=menu?panelOpen(menu):false;
    const task=navigation||taskOpen(document)||taskOpen(motive);
    const filters=[...document.querySelectorAll('#facets-drawer,.facets-drawer,.oh-native-tag-drawer')].some(panelOpen);
    const blocked=task||filters||!!document.querySelector('.oh-collection-filter__panel[aria-hidden="false"],#oh-tagsheet.is-open');
    state('og-help-overlay-open',blocked);
    state('og-task-overlay-open',task);
    host=document.querySelector('shopify-chat');
    if(!host)return;
    if(host.shadowRoot)watch(host.shadowRoot);
    const open=host.shadowRoot?expanded(host.shadowRoot):false;
    const faqs=[...document.querySelectorAll('main .shopify-section--faq,main .oh-faq-system,main .oh-meta-faq,main .oh-camp__faq,main .oh-help-acc,main .faqs,main .oh-faq,main .oh-th__acc')];
    const contact=document.querySelector('main .oh-help-contact');
    const anchor=faqs[faqs.length-1];
    if(!contact&&!anchor)return;
    if(!slot?.isConnected){
      slot=document.createElement('div');slot.className='og-chat-slot';
      if(contact)contact.append(slot);else anchor.after(slot);
    }
    if(host.parentElement!==slot)slot.append(host);
    toggle(host,'og-chat-docked',!open);
    toggle(slot,'og-chat-slot--open',open);
  };
  const start=()=>{
    new MutationObserver(enqueue).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['open','aria-hidden']});
    document.addEventListener('click',()=>{enqueue();setTimeout(enqueue,250);setTimeout(enqueue,1000);},true);
    sync();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
